import webContextProvider from "../../../../../../../providers/webContextProvider";

const getPageName = () => {
  const { platform, storeId } = webContextProvider();

  return `${platform} ${storeId}|wishlists - shared`;
};

export default getPageName;
